import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M8 11v-4a4 4 0 1 1 8 0v4","key":"svg-1"}],["path",{"d":"M15 16h.01","key":"svg-2"}],["path",{"d":"M12.01 16h.01","key":"svg-3"}],["path",{"d":"M9.02 16h.01","key":"svg-4"}]]

const IconLockPassword = createReactComponent('outline', 'lock-password', 'LockPassword', __iconNode);

export default IconLockPassword;